import React, { Component } from 'react';
import './apps.css';
import hangmanIcon from './img/hangmanIcon.png';
import xylophoneIcon from './img/xylophoneIcon.png';
import comoneyIcon from './img/comoneyIcon.png';
import comoneyLiteIcon from './img/comoneyLiteIcon.png';
import pairsIcon from './img/pairsIcon.png';
import planningPokerIcon from './img/planningPoker.png';
import appstoreBadge from './img/btn-apple-download.svg';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faArrowRight from '@fortawesome/fontawesome-free-solid/faAngleDoubleRight';

const igrecwayApps = [
    {
        key: "Hangman",
        appIcon: hangmanIcon,
        title: 'Hangman',
        website: 'http://hangman.igrecway.com',
        appstoreDownloadLink:'https://apps.apple.com/us/app/igrecway-hangman/id554531726',
        description: 'Hangman is a word guessing game which nearly every child has played at least once in their life. Now on your iPhone and iPad.'
    },
    {
        key: "xylophone",
        appIcon: xylophoneIcon,
        title: 'Xylophone',
        website: 'http://xylophone.igrecway.com',
        appstoreDownloadLink:'https://apps.apple.com/us/app/igrecway-xylophone/id608259356',
        description: 'Toddler-friendly toy app that will introduce your child to the world of music. Ideal app for keeping your child occupied while traveling, shopping or in a waiting room'},
    {
        key:"comoney",
        appIcon: comoneyIcon,
        title: 'Comoney',
        website: 'http://comoney.igrecway.com',
        appstoreDownloadLink:'https://apps.apple.com/us/app/comoney/id539362204',
        description: 'Do you need help with splitting expenses? Calculating split bills in a fair and accurate manner can be difficult! So that is where the Comoney App can help.'
    },
    {
        key: "comoneyLite",
        appIcon: comoneyLiteIcon,
        title: 'Comoney Lite',
        website: 'http://comoney.igrecway.com',
        appstoreDownloadLink:'https://apps.apple.com/us/app/comoney-lite/id593016733',
        description: 'Try before you buy. Lite version of Comoney app. Do you need help with splitting expenses? Calculating split bills in a fair and accurate manner can be difficult!'
    },
    {
        key: "pairs",
        appIcon: pairsIcon,
        title: 'Pairs',
        website: 'http://pairs.igrecway.com',
        appstoreDownloadLink:'https://apps.apple.com/us/app/igrecway-pairs-game-matching-game-for-your-toddler/id897087907',
        description: 'This kids app entertains your little one, while promoting greater concentration and a better memory - all while they have fun!'
    },
    {
        key: "planningPoker",
        appIcon: planningPokerIcon,
        title: 'Planning Poker',
        website: 'http://www.igrecway.com',
        appstoreDownloadLink:'https://apps.apple.com/us/app/igrecway-planning-poker/id960647115',
        description: 'Planning poker, also called Scrum poker, is a consensus-based technique for estimating, mostly used to estimate effort or relative size of development goals in software development. '
    }
    
  ];

class Apps extends Component {
   
  render() {
    return (
            <div className="row">
                {igrecwayApps.map(function(object, i){
                    return <div className="app-item col-sm-12 col-md-6 col-lg-4 mb-3" key={object.key}>
                                <div className="m-4">
                                    <a href={object.website}>
                                        <img src={object.appIcon} className="rounded mx-auto mb-3" alt={object.title}/>
                                    </a>
                                    <div className="pt-2"/>
                                    <a href={object.appstoreDownloadLink} className="pb-2">
                                        <img src={appstoreBadge} alt="Download"/>
                                    </a>
                                    
                                    <h2 className="iw-color-3 pt-2">
                                        {object.title}
                                    </h2>
                                    
                                    <div className="m-3 text-justify text-dark">
                                        {object.description}
                                        <a href={object.website} className="iw-color-4">
                                            <br/>Find out more <FontAwesomeIcon icon={faArrowRight} />
                                        </a>
                                    </div>
                                    
                                    <hr className="m-3 d-md-none"/>
                                </div>
                                
                            </div>;
                })}
            </div>
    );
  }
}

export default Apps;



// WEBPACK FOOTER //
// ./src/apps/apps.js